
$(document).ready(function() {
  updateModel()
    $(document).on('change', '.variant-picker__option-values input', function () {
      updateModel();
      console.log('changed');
    });
  function updateModel(){
    var checkedValue = $('.variant-picker__option-values input:checked').attr('color-value');

        var blue = "https://cdn.shopify.com/3d/models/d81f9fc1292a9fe3/blue.glb";
        var black = "https://cdn.shopify.com/3d/models/1e7ed62bdc75c1f1/black.glb";
        var white = "https://cdn.shopify.com/3d/models/83f1848746be5e53/white_1.glb";
        var green = "https://cdn.shopify.com/3d/models/92510f3f8a583bc2/green.glb";

        if(checkedValue == 'Blue') {
            $('model-viewer').attr('src', blue);
        } else if(checkedValue == 'Black') {
            $('model-viewer').attr('src', black);
        } else if(checkedValue == 'White') {
            $('model-viewer').attr('src', white);
        } else if(checkedValue == 'Green') {
            $('model-viewer').attr('src', green);
        }
  }


  $('.camera_on').click(function(){
    $('.camera_on_inner').toggleClass('control_off');
    if ($('.camera_on_inner').hasClass('control_off')) {
        // Remove the camera-controls attribute
        $('model-viewer').removeAttr('camera-controls');
    } else {
        // Add the camera-controls attribute
        $('model-viewer').attr('camera-controls', '');
    }
  })

  if(window.outerWidth < 999) {
    $('model-viewer').removeAttr('camera-controls');
  }

  
});

                                     